export const WIDTH_CONSTANTS = {
  MAX_PAGE_WIDTH_CONSTANT: '1200px',
  xl: '1060px',
  lg: '950px',
  md: '900px',
  sm: '800px',
  SIDEBAR_WIDTH: 52,
  PADDING_WIDTH: 48,
};

// Breakpoint max widths
export const BREAKPOINT_WIDTHS = {
  xl: 1060,
  lg: 950,
  md: 900,
} as const;
